















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { STATUSES } from '@/constants/risk_profile';
import { mapState } from 'vuex';
import RiskProfileListFilterForm from './List/RiskProfileListFilterForm.vue';
import RiskProfileListFilterChip from './List/RiskProfileListFilterChip.vue';
import { jsonToQueryString } from '../../../utils/utils';

@Component({
  components: {
    RiskProfileListFilterForm,
    RiskProfileListFilterChip,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
  },
})
export default class RiskProfileList extends Vue {
  activeBusiness!: Model;
  headers = [
    { text: 'Name', value: 'custom_job_role_name' },
    { text: 'Status', value: 'status', align: 'left', sortable: false },
    {
      text: 'Created At',
      value: 'created_at',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'left',
      sortable: false,
      width: '15%',
      cellClass: 'row-click-stop',
    },
  ];

  // Data
  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: 'updated_at',
    orderByDirection: 'desc',
    status: null,
  };
  statuses = STATUSES;
  isLoading = null;
  reloadList = 0;
  showConfirm = false;
  target: any = null;
  resetPage = false;

  @Watch('options', { immediate: false })
  watchOptions(newVal, oldVal) {
    this.resetPage =
      oldVal.query != newVal.query || oldVal.status != newVal.status;

    this.options.page = this.resetPage ? 1 : this.options.page;

    history.pushState(
      {},
      '',
      this.$route.path +
        '?' +
        jsonToQueryString({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          query: this.options.query,
          orderBy: this.options.orderBy,
          orderByDirection: this.options.orderByDirection,
          status: this.options.status,
        })
    );
  }

  // Methods
  handleFetch() {
    const options = {
      params: {
        search_name: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        status: this.options.status,
        expand: ['anzsco_occupation'],
      },
    };
    if (this.activeBusiness) {
      options.params['business_oid'] = this.activeBusiness.object_id;
    }
    return this.$store.dispatch('RiskProfile/fetchList', options);
  }

  toCreate() {
    this.$router.push({
      name: 'business-risk-profile-create',
      params: {
        businessOid: this.$route.params.businessOid,
      },
    });
  }

  toUpdate(oid) {
    const routeData = this.$router.resolve({
      name: 'business-risk-profile-update',
      params: {
        riskProfileOid: oid,
      },
    });
    window.open(routeData.href, '_blank');
  }

  toRead(oid) {
    const routeData = this.$router.resolve({
      name: 'business-risk-profile-read',
      params: {
        riskProfileOid: oid,
      },
    });
    window.open(routeData.href, '_blank');
  }

  toMakeBooking(oid) {
    this.$router.push({
      name: 'business-booking-create',
      query: {
        riskProfileOid: oid,
      },
    });
  }

  showMarkAsDraft(item) {
    return (
      item.status != this.statuses.STATUS_DRAFT.key && item.booking_count == 0
    );
  }

  markAsDraft(item) {
    this.isLoading = item.object_id;
    this.$store
      .dispatch('RiskProfile/update', {
        object_id: item.object_id,
        custom_job_role_name: item.custom_job_role_name,
        description: item.description,
        status: STATUSES.STATUS_DRAFT.key,
      })
      .then(() => {
        this.reloadList++;
      });
  }

  openModalDelete(item) {
    this.target = item;
    this.showConfirm = true;
  }

  closeModalDelete() {
    this.target = null;
    this.showConfirm = false;
  }

  deleteRiskProfile() {
    if (!this.target) {
      return;
    }
    this.$store
      .dispatch('RiskProfile/delete', this.target.object_id)
      .then(() => {
        this.showConfirm = false;
        this.reloadList++;
      });
  }

  handleClick(item) {
    if (item.status === this.statuses.STATUS_DRAFT.key) {
      this.toUpdate(item.object_id);
    } else {
      this.toRead(item.object_id);
    }
  }

  handleDuplicate(item) {
    this.$store.dispatch('RiskProfile/duplicate', item.object_id).then(() => {
      this.reloadList++;
    });
  }
}
